import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button, Typography } from "@bookips/sds";
import Image from "next/image";
import Link from "next/link";
import CountdownModule from "./CountdownModule";
const PromotionBanner = (param)=>{
    let { imageUrl , imageUrlMobile , labelText , countDownHeaderText , buttonLabel , buttonLink , useCountDown =false , countDownPosition ="top" , className , buttonVariant ="stroke" , buttonColor ="secondary" , onButtonClick  } = param;
    const { isMobile  } = useWindowDimensions();
    // 모바일일 때 모바일 이미지 사용, 없으면 PC 이미지 fallback
    const displayImageUrl = isMobile ? imageUrlMobile || imageUrl : imageUrl;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("relative overflow-hidden rounded-md", "h-[480px] w-[224px] max-sm:h-[260px] max-sm:w-[140px]", className),
        children: [
            buttonLink && /*#__PURE__*/ _jsx(Link, {
                href: buttonLink,
                onClick: onButtonClick,
                className: "absolute inset-0 z-20 cursor-pointer",
                "aria-label": labelText !== null && labelText !== void 0 ? labelText : buttonLabel
            }),
            displayImageUrl ? /*#__PURE__*/ _jsx(Image, {
                src: displayImageUrl,
                alt: "".concat(labelText, " 배너"),
                fill: true,
                className: "object-cover"
            }) : /*#__PURE__*/ _jsx("div", {
                className: "absolute inset-0 bg-gray-200"
            }),
            labelText && /*#__PURE__*/ _jsx(Typography, {
                variant: isMobile ? "subtitle1" : "h5",
                className: "relative z-10 flex w-full justify-center px-4 pt-6 text-center break-keep text-white max-sm:px-2 max-sm:pt-3",
                children: labelText
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn("z-10 flex flex-col items-center justify-center gap-3 px-4 max-sm:gap-2 max-sm:px-2", countDownPosition === "top" ? "relative pt-3 max-sm:pt-2" : buttonLabel ? "absolute right-0 bottom-16 left-0 pb-2 max-sm:bottom-10" : "absolute right-0 bottom-0 left-0 pb-4 max-sm:pb-2"),
                children: useCountDown && /*#__PURE__*/ _jsx(CountdownModule, {
                    text: countDownHeaderText
                })
            }),
            buttonLabel && buttonLink && /*#__PURE__*/ _jsx("div", {
                className: "absolute right-0 bottom-0 left-0 z-10 p-4 max-sm:p-2",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: buttonVariant,
                    color: buttonColor,
                    size: isMobile ? "sm" : "lg",
                    className: "w-full shadow-sm",
                    children: buttonLabel
                })
            })
        ]
    });
};
export default PromotionBanner;
